<template>
  <div class="upgraded">
    <b-loading :active="loading" />
    <h1 class="upgraded__title">恭喜！已成功升級到標準方案！</h1>
    <p class="upgraded__description">
      即日起貴司的方案即從輕量方案轉換成『標準方案』，可隨時增加、減少帳號，每月每天啟用中的帳號數將於下次帳單寄送告知。
    </p>
    <div class="columns upgraded__intro">
      <div class="column">
        <div class="info">
          <img src="@/assets/images/upgraded-member-count.svg">
          <hr>
          <div class="info__content">
            <h3 class="info__title">
              目前啟用人數
            </h3>
            <span class="info__value">{{ memberLength }}人</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="info">
          <img src="@/assets/images/upgraded-fee.svg">
          <hr>
          <div class="info__content">
            <h3 class="info__title">
              預估每月費用
            </h3>
            <span class="info__value">${{ monthlyPrice | commaFormat }}</span>
          </div>
        </div>

        <router-link
          to="/setting"
          class="button is-primary is-outlined is-fullwidth mt-6">
          返回公司帳戶
        </router-link>
      </div>
      <div class="column">
        <div class="info">
          <img src="@/assets/images/upgraded-calendar.svg">
          <hr>
          <div class="info__content">
            <h3 class="info__title">
              下次出帳日期<br><small>(每月最後一日)</small>
            </h3>
            <span class="info__value">{{ nextPaymentDate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Upgraded from './Upgraded';

export default Upgraded;
</script>

<style lang="scss" scoped>
@import 'Upgraded';
</style>
